module.exports = [{
      plugin: require('C:/Users/Andreas/Desktop/dev/gatsbygalore/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Permanent Marker","Special Elite","Lato","sans-serif"]}},
    }]
